module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td id="payment_item-'+
((__t=( id ))==null?'':_.escape(__t))+
'">'+
((__t=( name ))==null?'':_.escape(__t))+
'</td>\n<td class="match grid3">\n  <select class="match"></select>\n</td>\n<td>\n  <button type="button" class="button button-secondary remove-paymentitem">\n    ';
 if (is_active) { 
__p+='\n    Hide\n    ';
 } else { 
__p+='\n    Show\n    ';
 } 
__p+='\n  </button>\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./epayment/templates/paymentitem/row.html
// module id = 327
// module chunks = 0